<section
  class="eventq-schedule-list"
  [attr.aria-busy]="loading() ? true : null"
  [attr.aria-label]="heading()"
>
  <header class="eventq-schedule-list__header">
    <h3 class="eventq-schedule-list__heading">{{ heading() }}</h3>
  </header>

  <div class="eventq-schedule-list__body">
    @if (loading()) {
      @for (index of skeletonIndexes(); track index) {
        <div class="eventq-schedule-list__skeleton" aria-hidden="true">
          <span class="eventq-schedule-list__skeleton-line eventq-schedule-list__skeleton-line--title"></span>
          <span class="eventq-schedule-list__skeleton-line"></span>
          <span class="eventq-schedule-list__skeleton-line eventq-schedule-list__skeleton-line--short"></span>
        </div>
      }
    } @else if (isEmpty()) {
      <p class="eventq-schedule-list__empty">{{ emptyLabel() }}</p>
    } @else {
      @for (entry of entries(); track entry.id) {
        <div class="eventq-schedule-list__row">
          <eventq-schedule-entry
            [title]="entry.title ?? null"
            [days]="entry.days"
            [time]="entry.time"
            [calendarIconSrc]="calendarIconSrc()"
            [clockIconSrc]="clockIconSrc()"
          />
        </div>
      }
    }
  </div>
</section>
